import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import { useNavigate } from "react-router-dom";
import Modal from 'react-bootstrap/Modal';
import Card from 'react-bootstrap/Card';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import css from "../../css/user/navbar.module.css";
import userTypeModalCss from "../../css/common/user-type-modal.module.css";

function UserTypeModal({ text }) {
    const [show, setShow] = useState(false);
    const navigate = useNavigate();
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleYuvaLoginClick = (e) => {
        navigate("/yuva-login");
        handleClose();
    };
    const handleThalirLoginClick = (e) => {
        navigate("/thalir-login");
        handleClose();
    };

    return (
      <>
        <Button
          className={`${css.navBtn} text-ff1 navbar-right`}
          onClick={handleShow}
        >
          {text ? text : "Click Me"}
        </Button>

        <Modal show={show} onHide={handleClose} size="lg">
          <Modal.Header closeButton style={{ border: "none" }}>
            <Modal.Title className={userTypeModalCss.cardTitle}>
              Choose Platform
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
              <p style={{ color: '#666', fontSize: '1rem' }}>
                Please select the platform you want to login to:
              </p>
            </div>
            
            {/* Platform Selection */}
            <Row className="d-flex justify-content-center">
              <Col md={6}>
                <Card
                  className={`mt-2 ${userTypeModalCss.userTypeCard}`}
                  onClick={handleYuvaLoginClick}
                  style={{ 
                    cursor: 'pointer',
                    border: '2px solid var(--yuva-blue)',
                    transition: 'all 0.3s ease'
                  }}
                >
                  <Card.Body className="d-flex flex-column justify-content-center align-items-center">
                    <div style={{ 
                      fontSize: '3rem', 
                      marginBottom: '1rem',
                      color: 'var(--yuva-blue)'
                    }}>
                      🎓
                    </div>
                    <Card.Title className={userTypeModalCss.cardTitle} style={{ color: 'var(--yuva-blue)' }}>
                      YUVA
                    </Card.Title>
                    <p style={{ fontSize: '0.9rem', color: '#666', margin: '0.5rem 0' }}>
                      Yi Learning Beyond Education
                    </p>
                  </Card.Body>
                </Card>
              </Col>
              <Col md={6}>
                <Card
                  className={`mt-2 ${userTypeModalCss.userTypeCard}`}
                  onClick={handleThalirLoginClick}
                  style={{ 
                    cursor: 'pointer',
                    border: '2px solid #28a745',
                    transition: 'all 0.3s ease'
                  }}
                >
                  <Card.Body className="d-flex flex-column justify-content-center align-items-center">
                    <div style={{ 
                      fontSize: '3rem', 
                      marginBottom: '1rem',
                      color: '#28a745'
                    }}>
                      🌱
                    </div>
                    <Card.Title className={userTypeModalCss.cardTitle} style={{ color: '#28a745' }}>
                      Thalir
                    </Card.Title>
                    <p style={{ fontSize: '0.9rem', color: '#666', margin: '0.5rem 0' }}>
                      Let's Nurture From School
                    </p>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Modal.Body>
          <div>
            <br></br>
          </div>
        </Modal>
      </>
    );
}

export default UserTypeModal;